import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';
// import { toSearchableString, sortNumber, sortString } from 'app/utils';
// import * as _ from 'lodash';

const TEMPLATE_NAME = 'BUSINESS_PARTNER';

export default createListReducer(TEMPLATE_NAME);

// const initialState = () => ({
//   loading: false,
//   loadedData: [],
//   filters: {
//     term: '',
//     data: []
//   }
// });

// const sort = function (a, b) {
//   let result = sortNumber(a.status, b.status);
//   if (result !== 0) {
//     return result;
//   }
//   const aName = a.name || null;
//   const bName = b.name || null;
//   result = sortString(aName, bName);
//   if (result !== 0) {
//     return result;
//   }
//   return sortString(a.key, b.key);
// };

// const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

// const filterData = (data, term) => {
//   const result = data.filter(item => {
//     const businessPartnerName = item.name ? filterByTerm(item.name, term) : false;
//     const businessPartnerCnpj = item.cnpj ? filterByTerm(item.cnpj, term) : false;
//     const businessPartnerClientName = item.client.name
//       ? filterByTerm(item.client.name, term)
//       : false;

//     return businessPartnerName || businessPartnerCnpj || businessPartnerClientName;
//   });
//   if (sort) {
//     result.sort(sort);
//   }

//   return result;
// };

// const reducer = (state = initialState(), action) => {
//   switch (action.type) {
//     case `${TEMPLATE_NAME}_PENDING`: {
//       return {
//         ...state,
//         loading: true
//       };
//     }

//     case `${TEMPLATE_NAME}_REJECTED`: {
//       return {
//         ...state,
//         loading: false
//       };
//     }

//     case `${TEMPLATE_NAME}_FULFILLED`: {
//       const newData = action.payload;
//       return {
//         ...state,
//         loading: false,
//         loadedData: newData,
//         filters: {
//           ...state.filters,
//           data: newData
//         }
//       };
//     }

//     case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
//       const currentData = state.loadedData;
//       const newData = action.payload;

//       return {
//         ...state,
//         loading: false,
//         loadedData: [...currentData, ...newData],
//         filters: {
//           ...state.filters,
//           data: !_.isEmpty(newData) ? [...currentData, ...newData] : currentData
//         }
//       };
//     }

//     case `${TEMPLATE_NAME}_RESET`: {
//       return initialState();
//     }

//     // case `${TEMPLATE_NAME}_SEARCH`: {
//     //   const term = action.payload;
//     //   return {
//     //     ...state,
//     //     filters: {
//     //       ...state.filters,
//     //       term,
//     //       data: filterData(state.loadedData, term),
//     //     },
//     //   };
//     // }

//     case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
//       return {
//         ...state,
//         loading: true
//       };
//     }

//     case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
//       return {
//         ...state,
//         loading: false
//       };
//     }

//     case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
//       const { data /* , searchTerm */ } = action.payload;
//       return {
//         ...state,
//         loading: false,
//         filters: {
//           ...state.filters,
//           data
//         }
//       };
//     }

//     case `${TEMPLATE_NAME}_UPDATE`: {
//       const updatedRow = action.payload;
//       const loadedData = state.loadedData.map(row => (row.id === updatedRow.id ? updatedRow : row));

//       return {
//         ...state,
//         loadedData,
//         filters: {
//           ...state.filters,
//           data: filterData(loadedData, state.filters.term)
//         }
//       };
//     }

//     case `${TEMPLATE_NAME}_CREATE`: {
//       const newRow = action.payload;
//       const loadedData = [...state.loadedData, newRow];
//       return {
//         ...state,
//         loading: false,
//         loadedData,
//         filters: {
//           ...state.filters,
//           data: filterData(loadedData, state.filters.term, state.filters.type)
//         }
//       };
//     }

//     default:
//       return state;
//   }
// };

// export default reducer;
